import { StripeProduct } from "@kvix/shared";
import { Grid, makeStyles } from "@material-ui/core";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Redirect, useHistory } from "react-router";
import { KvixUserContext } from "../../../contexts/user";
import { MetaData } from "../../partials/Meta";
import { Page } from "../../partials/Page";
import { CheckoutStep } from "../../PurchaseFlow";

const useStyles = makeStyles((theme) => ({
  box: {
    textAlign: "center",
  },
}));

const Subscribe: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const { user } = useContext(KvixUserContext);
  const { t, ready } = useTranslation("signUp");
  const { title, description, ogTitle, ogImage }: MetaData =
    history.location?.state || {};

  const getMetaData = () => {
    return {
      title: title || t("signUpText"),
      ogTitle: ogTitle || "Kvix",
      description: description || t("metaDescription"),
      ogImage,
    } as MetaData;
  };

  if (!user) {
    return <Redirect to={"/login"} />;
  }

  if (user.stripeProducts?.includes(StripeProduct.LIVE)) {
    return <Redirect to={"/"} />;
  }

  if (!ready) {
    return null;
  }

  return (
    <Page meta={getMetaData()} noGutter>
      <Grid container alignItems="center" justify="center">
        <Grid item md={3} className={classes.box}>
          <CheckoutStep />
        </Grid>
      </Grid>
    </Page>
  );
};

export default Subscribe;
